import React from "react";

const OrderCreationAuctionIcon = ({ color = "#6D7885", ...rest }) => {
  return (
    <svg preserveAspectRatio="none" overflow="visible" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g>
        <path d="M12.9601 20.0295V22H1V20.0295H12.9601ZM13.5432 1L21.2953 8.66341L19.886 10.0566L18.8286 9.70878L16.3618 12.1473L22 17.721L20.5907 19.1142L14.9525 13.5405L12.5565 15.9091L12.8385 17.0244L11.4282 18.4176L3.67608 10.7542L5.08538 9.36L6.21362 9.63883L12.4857 3.43854L12.1339 2.39415L13.5432 1Z" fill={color} />
      </g>
    </svg>
  );
};

export default OrderCreationAuctionIcon;
